import { useTranslation as e } from "../../i18n.mjs";
import { FilePreview as t } from "../file-preview/index.mjs";
import { formatBytes as n } from "../../utils/format-bytes.mjs";
import { Button as r } from "@systemeio/components";
import { twMerge as i } from "tailwind-merge";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
import { XCloseIcon as c } from "@systemeio/icons";
//#region src/components/file-details/index.tsx
function l({ fileType: l, src: u, alt: d, name: f, size: p, className: m, onClose: h, showCloseButton: g = !0, isFetching: _ }) {
	let { t: v } = e();
	return _ ? /* @__PURE__ */ s("div", {
		className: i("flex w-full flex-col items-end", m),
		children: [g && /* @__PURE__ */ o(r, {
			"aria-label": v("file_manager.cancel"),
			className: "mb-5",
			onClick: h,
			size: "icon-sm",
			variant: "ghost-gray",
			children: /* @__PURE__ */ o(c, {})
		}), /* @__PURE__ */ s("div", {
			className: "flex w-full flex-col",
			children: [
				/* @__PURE__ */ o("div", { className: "bg-bg-tertiary h-[300px] w-full animate-pulse rounded-md" }),
				/* @__PURE__ */ o("div", { className: "bg-bg-tertiary mt-5 h-4 w-16 animate-pulse rounded-sm" }),
				/* @__PURE__ */ o("div", { className: "bg-bg-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" }),
				/* @__PURE__ */ o("div", { className: "bg-bg-tertiary mt-2 h-4 w-16 animate-pulse rounded-sm" }),
				/* @__PURE__ */ o("div", { className: "bg-bg-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" })
			]
		})]
	}) : /* @__PURE__ */ s("div", {
		className: i("flex w-full flex-col items-end", m),
		children: [g && /* @__PURE__ */ o(r, {
			"aria-label": v("file_manager.cancel"),
			className: "mb-5",
			onClick: h,
			size: "icon-sm",
			variant: "ghost-gray",
			children: /* @__PURE__ */ o(c, {})
		}), /* @__PURE__ */ s("div", {
			className: "flex w-full flex-col",
			children: [
				/* @__PURE__ */ o(t, {
					src: u ?? "",
					fileType: l,
					alt: d
				}),
				f && /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ o("div", {
					className: "text-text-secondary mt-5 truncate overflow-clip text-sm",
					style: { lineHeight: 1.1 },
					children: v("file_manager.name")
				}), /* @__PURE__ */ o("div", {
					className: "text-text-tertiary mt-2 truncate text-base font-semibold",
					title: f,
					style: { lineHeight: 1.1 },
					children: f
				})] }),
				typeof p == "number" && /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ o("div", {
					className: "text-text-secondary mt-[10px] truncate overflow-clip text-sm",
					style: { lineHeight: 1.1 },
					children: v("file_manager.size")
				}), /* @__PURE__ */ o("div", {
					className: "text-text-tertiary mt-2 text-base font-semibold",
					style: { lineHeight: 1.1 },
					children: n(p)
				})] })
			]
		})]
	});
}
//#endregion
export { l as FileDetails };
